import { render, staticRenderFns } from "./GameRecordAllSearchBarComponent.vue?vue&type=template&id=2bfd93ec&scoped=true"
import script from "./GameRecordAllSearchBarComponent.vue?vue&type=script&lang=js"
export * from "./GameRecordAllSearchBarComponent.vue?vue&type=script&lang=js"
import style0 from "./GameRecordAllSearchBarComponent.vue?vue&type=style&index=0&id=2bfd93ec&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bfd93ec",
  null
  
)

export default component.exports